{
  "fr": {
    "task": {
      "actions": {
        "create": "Tâche",
        "create_and_send": "Créer et envoyer",
        "delete": "Supprimer la tâche",
        "open_in_project": "Ouvrir la tâche dans le projet",
        "remove_from_unit": "Retirer la tâche de cette unité",
        "save_as_draft": "Enregistrer comme brouillon",
        "update": "Modifier la tâche"
      },
      "attributes": {
        "assignments_count": "Assignations",
        "category": "Méthode de clôture",
        "created_at": "Créé le",
        "description": "Description",
        "phase": "Phase",
        "title": "Titre",
        "units": "Unités"
      },
      "categories": {
        "confirmation": "Confirmation",
        "upload": "Téléversement de document"
      },
      "categories_info": {
        "confirmation": "La personne assignée coche la tâche une fois qu'elle est faite.",
        "upload": "La personne assignée doit téléverser un document pour terminer la tâche."
      },
      "confirm": {
        "delete_body": "La tâche disparaît, ainsi que toutes ses attributions : {assignments} sur {units}.",
        "delete_header": "Supprimer « {title} » ?",
        "delete_silent": "Personne n'est notifié, et les notifications déjà envoyées ne sont pas retirées.",
        "remove_from_unit_body": "Chaque personne assignée à « {title} » sur {unit} la perd. La tâche elle-même et ses autres unités restent inchangées.",
        "remove_from_unit_customers": "Les clients de {unit} ne la voient plus dans leur portail.",
        "remove_from_unit_header": "Retirer cette tâche de {unit} ?"
      },
      "deep_link": {
        "show_all": "Afficher toutes les tâches",
        "single": "Vous consultez une tâche issue d'une notification."
      },
      "empty": {
        "filtered_description": "Ajuste tes filtres ou efface-les pour voir toutes les tâches.",
        "filtered_title": "Aucune tâche ne correspond à tes filtres",
        "none_title": "Aucune tâche"
      },
      "filters": {
        "phase_none": "Aucune phase"
      },
      "labels": {
        "assignments_count": "{count} attribution | {count} attributions",
        "created_by": "Créé par {name} · {date}",
        "created_on": "Créé le {date}",
        "no_tasks": "Aucune tâche pour ce projet pour le moment.",
        "required": "Ce champ est obligatoire",
        "set_all_assignees": "Définir la personne assignée | Définir les {count} personnes assignées",
        "still_to_do": "{count} encore à faire",
        "units_count": "{count} unité | {count} unités",
        "units_required": "Sélectionnez au moins une unité"
      },
      "toasts": {
        "create": "Tâche créée",
        "delete": "Tâche supprimée",
        "remove_from_unit": "Tâche retirée de cette unité",
        "update": "Tâche mise à jour"
      }
    }
  }
}
